import dayjs from 'dayjs'
import request from '@/request/request'
import { VxeUI } from 'vxe-pc-ui'
const CreateNewDocument = (firstletter) => { 
    return firstletter + dayjs().format('YYYYMMDDHHmmss')
}
const SaveDocument =async (doc,detail) => { 
    try { 
        const filteredDetail = detail.filter(item => item.spbh !== '')
        let products = []
        filteredDetail.forEach(item => { 
            products.push(
                {
                    ckdh: doc.ckdh,
                    spbh: item.spbh,
                    dj: item.price,
                    sl: item.num,
                    hj: item.total,
                    bz: item.remark,
                    cbj: 0,
                    sP_DW: item.unit,
                    sP_QM: item.fullname
                })
        })
         let res =await request.post('/SaleDoc/SaveSaleDoc', { doc, products })
        if(res.code===200){
            return true
        }
        else{
            alert(res.message)
            return false
        }
    } catch (error) { 
       alert(error)
        return false
    }
       
}
const SaveEditDocument =async (doc,detail) => { 
    try { 
        const filteredDetail = detail.filter(item => item.spbh !== '')
        let products = []
        filteredDetail.forEach(item => { 
            products.push(
                {
                    ckdh: doc.ckdh,
                    spbh: item.spbh,
                    dj: item.price,
                    sl: item.num,
                    hj: item.total,
                    bz: item.remark,
                    cbj: 0,
                    sP_DW: item.unit,
                    sP_QM: item.fullname
                })
        })
         let res =await request.post('/SaleDoc/EditSaleSave', { doc, products })
        if(res.code===200){
            return true
        }
        else{
            alert(res.message)
            return false
        }
    } catch (error) { 
       alert(error)
        return false
    }
       
}
const GetDocDetail=async (docNum) => { 
    try { 
        let res =await request.get('/SaleDoc/GetSaleDocDetail', {
            params: { docNum: docNum }
        })
       
        if(res.code===200){
            return res.data
        }
        else{
            VxeUI.modal.message({
                id: 'myUniqueMsg',
                content: res.message,
                status: 'error'
            })
            return []
        }
    } catch (error) { 
       VxeUI.modal.message({
            id: 'myUniqueMsg',
            content: error,
            status: 'error'
        })
        return []
    }
       
}
const GetOneDoc=async (docNum) => { 
    try { 
        let res =await request.get('/SaleDoc/GetOneSaleDoc', {
            params: { docNum: docNum }
        })
        if(res.code===200){
            return res.data
        }
        else{
            VxeUI.modal.message({
                id: 'myUniqueMsg',
                content: res.message,
            })
        }
    }
    catch (error) { 
       VxeUI.modal.message({
            id: 'myUniqueMsg',
            content: error,
        })
    }
}
const CeatrandomUUID=() => { 
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) { 
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    })
}
const DeleteSaleDoc =async (docNum) => { 
    try { 
        let res =await request.delete('/SaleDoc/DeleteSaleDoc', {
            params: { docNum: docNum }
        })
        if(res.code===200){
            return true
        }
        else{
            VxeUI.modal.message({
                id: 'myUniqueMsg',
                content: res.message,
            })
        }
    }
    catch (error) { 
       VxeUI.modal.message({
            id: 'myUniqueMsg',
            content: error,
        })
    }
}
export { CreateNewDocument, SaveDocument, GetDocDetail,GetOneDoc, CeatrandomUUID,SaveEditDocument,DeleteSaleDoc } 